import React from "react";
import SuperAdminDashboard from "./screens/SuperAdminDashboard";
import SuperAdminCreateAdmin from "./screens/SuperAdminCreateAdmin";
import SuperAdminCreateSuperAdmin from "./screens/SuperAdminCreateSuperAdmin";
import SuperAdminProfileEdit from "./screens/SuperAdminProfileEdit";
import CompanyDetailsInterface from "./screens/CompanyDetailsInterface";
import Chat from "../Chat/Chat";
import dashboard_icon from "../../assets/img/dashboardIcon.png";
import add_user_icon from "../../assets/img/add_icon.svg";

const getRoutes = (t) => [
  {
    path: "/dashboard",
    name: 'dashboard',
    icon: dashboard_icon,
    component: <SuperAdminDashboard />,
    layout: "/superadmin",
  },
  {
    path: "/profile",
    name: 'superAdmin.routes.profile',
    icon: add_user_icon,
    component: <SuperAdminProfileEdit />,
    layout: "/superadmin",
  },
  {
    path: "/create-admin",
    name: 'superAdmin.routes.createAdmin',
    icon: add_user_icon,
    component: <SuperAdminCreateAdmin />,
    layout: "/superadmin",
  },
  {
    path: "/create-superadmin",
    name: 'superAdmin.routes.createSuperAdmin',
    icon: add_user_icon,
    component: <SuperAdminCreateSuperAdmin />,
    layout: "/superadmin",
  },
  // Chat route for super admin to communicate with admins
  // {
  //   path: "/chat",
  //   name: 'Chat',
  //   icon: "fas fa-comment",
  //   component: <Chat />,
  //   layout: "/superadmin",
  // },
  // In routes:
{
  path: "/company/:adminId",
  name: 'Company Details',
  icon: dashboard_icon,
  component: <CompanyDetailsInterface />,
  layout: "/superadmin",
  invisible: true,
}
];

export default getRoutes;


